export const products =  [
  {
    "productName": "ADS-4300N Desktop Document Scanner High-speed network desktop scanner",
    "category": "scanners",
    "subCategory": "desktop scanners",
    "productImages": [
      "\\img\\product\\ADS-4300N-1.jpg",
      "\\img\\product\\ADS-4300N-2.jpg"
    ],
    "description": "2-sided scan up to 80 images per minute\n80 sheet Automatic Document Feeder (ADF)\nMobile Connect App\nDriver compatibility with TWAIN (Win, macOS), WIA, ISIS, Linux SAN\nAdvanced image processing and batch scan\nUltrasonic Multifeed Sensor, Separation Switch"
  },
  {
    "productName": "DCP-B7500D Cost effective 3-in-1 Multi-Function Printer with Automatic 2-sided Printing Cost effective 3-in-1 Multi-Function printer with Automatic 2-sided Printing",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-B7500D-1.jpg",
      "\\img\\product\\DCP-B7500D-2.jpg",
      "\\img\\product\\DCP-B7500D-3.jpg",
      "\\img\\product\\DCP-B7500D-4.jpg",
      "\\img\\product\\DCP-B7500D-5.jpg",
      "\\img\\product\\DCP-B7500D-6.jpg"
    ],
    "description": "A4 print speed up to 34 ppm (Black)\nUSB 2.0\nAuto 2-sided (Duplex) printing, 2-line LCD, 128 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\n1 Year on-site warranty included"
  },
  {
    "productName": "DCP-B7535DW Cost effective 3-in-1 Multi-Function Printer with Automatic 2-sided Printing and Wireless Networking Cost effective 3-in-1 Multi-Function printer with Automatic 2-sided Printing and Wireless Networking",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-B7535DW-1.jpg",
      "\\img\\product\\DCP-B7535DW-2.jpg",
      "\\img\\product\\DCP-B7535DW-3.jpg",
      "\\img\\product\\DCP-B7535DW-4.jpg"
    ],
    "description": "A4 print speed up to 34 ppm (Black)\nWiFi, AirPrint, Mopria, WiFi Direct, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 50 sheets Auto-Document Feeder (ADF), 2-line LCD, 128 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\n1 Year on-site warranty included"
  },
  {
    "productName": "DCP-B7600D",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-B7600D-1.jpg",
      "\\img\\product\\DCP-B7600D-2.jpg"
    ],
    "description": "Up to 34/36 ppm\nAutomatic 2-sided (Duplex) Print"
  },
  {
    "productName": "DCP-B7600DB Multifunction Duplex Laser Printer Brother DCP-B7600DB Fast Multifunction Duplex Printer, Best For Business With Affordable Toner",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-B7600DB-1.jpg",
      "\\img\\product\\DCP-B7600DB-2.jpg"
    ],
    "description": "A4 print speed up to 34 ppm (Black)\nUSB 2.0\nAuto 2-sided (Duplex) printing, Intuitive Buttons, 2 Line LCD Display, 256 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\nCompatible Brother Apps - BRAdmin Pro4 : Windows App (By Download)\n1 Year on-site warranty included"
  },
  {
    "productName": "DCP-B7620DW",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-B7620DW-1.jpg",
      "\\img\\product\\DCP-B7620DW-2.jpg",
      "\\img\\product\\DCP-B7620DW-3.jpg",
      "\\img\\product\\DCP-B7620DW-4.jpg",
      "\\img\\product\\DCP-B7620DW-5.jpg",
      "\\img\\product\\DCP-B7620DW-6.jpg"
    ],
    "description": "Up to 34/36 ppm\nAutomatic 2-sided (Duplex) Print\nWireless Connectivity"
  },
  {
    "productName": "DCP-B7620DWB Multifunction WIFi Duplex Laser Printer Brother DCP-B7620DWB Fast Multifunction WIFI Duplex Printer, Best For Business With Affordable Toner",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-B7620DWB-1.jpg",
      "\\img\\product\\DCP-B7620DWB-2.jpg"
    ],
    "description": "A4 print speed up to 34 ppm (Black)\nUSB 2.0, LAN, WiFi, WiFi Direct, AirPrint, Mopria, Mobile Connect\nAuto 2-sided (Duplex) printing, Intuitive Buttons, 2 Line LCD Display, 256 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\nCompatible Brother Apps - BRAdmin Light, BRAdmin Pro4 : Windows App (By Download)\n1 Year on-site warranty included"
  },
  {
    "productName": "DCP-B7640DW",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-B7640DW-1.jpg",
      "\\img\\product\\DCP-B7640DW-2.jpg",
      "\\img\\product\\DCP-B7640DW-3.jpg",
      "\\img\\product\\DCP-B7640DW-4.jpg",
      "\\img\\product\\DCP-B7640DW-5.jpg",
      "\\img\\product\\DCP-B7640DW-6.jpg"
    ],
    "description": "Up to 34/36 ppm\nAutomatic 2-sided (Duplex) Print\nAutomatic Doucment Feeder (up to 50 Sheets(A4/Letter))"
  },

  {
    "productName": "DCP-L2520D 3-in-1 Monochrome Laser Multi-Function Centre",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-L2520D-1.jpg",
      "\\img\\product\\DCP-L2520D-2.jpg"
    ],
    "description": "A4 print speed up to 30 ppm (Black)\nUSB 2.0\nAuto 2-sided (Duplex) printing, 2-line LCD, 2 in 1 (ID) Copy,32 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\nCompatible with Brother iPrint&Scan Mobile App** & BR Admin**\n1 Year on-site warranty included"
  },

  {
    "productName": "DCP-L2541DW 3-in-1 Monochrome Laser Multi-Function Centre",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-L2541DW-1.jpg",
      "\\img\\product\\DCP-L2541DW-2.jpg",
      "\\img\\product\\DCP-L2541DW-3.jpg",
      "\\img\\product\\DCP-L2541DW-4.jpg",
      "\\img\\product\\DCP-L2541DW-5.jpg",
      "\\img\\product\\DCP-L2541DW-6.jpg"
    ],
    "description": "A4 print speed up to 30 ppm (Black)\nWiFi, AirPrint, Mopria, WiFi Direct, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 35 sheets Auto-Document Feeder (ADF), 2-line LCD, 2 in 1 (ID) Copy, 32 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\nCompatible with Brother iPrint&Scan Mobile App** & BR Admin**\n1 Year on-site warranty included"
  },
  {
    "productName": "DCP-L2605DW Multifunction Duplex WIFI Laser Printer Brother DCP-L2605DW Multifunction Dual Band WIFI Duplex Printer",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-L2605DW-1.jpg",
      "\\img\\product\\DCP-L2605DW-2.jpg",
      "\\img\\product\\DCP-L2605DW-3.jpg",
      "\\img\\product\\DCP-L2605DW-4.jpg",
      "\\img\\product\\DCP-L2605DW-5.jpg",
      "\\img\\product\\DCP-L2605DW-6.jpg"
    ],
    "description": "A4 print speed up to 30 ppm (Black)\nUSB 2.0, LAN, WiFi, WiFi Direct, AirPrint, Mopria, Mobile Connect\nAuto 2-sided (Duplex) printing, Intuitive Buttons, 2 Line LCD Display, 256 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 3000 pages (black)*\nCompatible Brother Apps - BRAdmin Light, BRAdmin Pro4 : Windows App (By Download)\n1 Year on-site warranty included"
  },
  {
    "productName": "DCP-L2640DW Multifunction Duplex WIFI ADF Laser Printer Brother DCP-L2640DW Fast Multifunction Dual Band WIFI Duplex ADF Printer",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-L2640DW-1.jpg",
      "\\img\\product\\DCP-L2640DW-2.jpg",
      "\\img\\product\\DCP-L2640DW-3.jpg",
      "\\img\\product\\DCP-L2640DW-4.jpg",
      "\\img\\product\\DCP-L2640DW-5.jpg",
      "\\img\\product\\DCP-L2640DW-6.jpg"
    ],
    "description": "A4 print speed up to 34 ppm (Black)\nUSB 2.0, LAN, WiFi, WiFi Direct, AirPrint, Mopria, Mobile Connect\nAuto 2-sided (Duplex) printing, ADF (Automatic Document Feeder), Intuitive Buttons, 2 Line LCD Display, 256 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 3000 pages (black)*\nCompatible Brother Apps - BRAdmin Light, BRAdmin Pro4 : Windows App (By Download)\n1 Year on-site warranty included"
  },
  {
    "productName": "DCP-L2680DW Multifunction Duplex WIFI Laser Printer Brother DCP-L2680DW Fast Multifunction WIFI Duplex Printer For Office",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-L2680DW-1.jpg",
      "\\img\\product\\DCP-L2680DW-2.jpg"
    ],
    "description": "A4 print speed up to 34 ppm (Black)\nUSB 2.0, LAN, WiFi, WiFi Direct, AirPrint, Mopria, Mobile Connect\nAuto 2-sided (Duplex) printing, Intuitive Buttons, 2.7 Inch TFT colourLCD Display, 256 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 3000 pages (black)*\nCompatible Brother Apps - BRAdmin Light, BRAdmin Pro4 : Windows App (By Download)\n1 Year on-site warranty included"
  },
  {
    "productName": "DCP-L3551CDW : Wireless Colour LED 3-in-One, Duplex Mobile Print ADF Colour LED Multi-Function Centre with Wireless & Network Connectivity, Automatic 2-sided Colour Print, ADF - Multi-page Scan & Copy, High Productivity with Fast Print Speeds, Wi-Fi Direct, Mobile & USB Print, Low Cost Quality Print Resolution with Affordable Toner",
    "category": "printers",
    "subCategory": "laser printers",
    "productImages": [
      "\\img\\product\\DCP-L3551CDW-1.jpg",
      "\\img\\product\\DCP-L3551CDW-2.jpg",
      "\\img\\product\\DCP-L3551CDW-3.jpg",
      "\\img\\product\\DCP-L3551CDW-4.jpg",
      "\\img\\product\\DCP-L3551CDW-5.jpg",
      "\\img\\product\\DCP-L3551CDW-6.jpg"
    ],
    "description": "A4 print speed up to 18 ppm (Black/Colour)\nWiFi, AirPrint, Mopria, WiFi Direct, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 50 sheets Auto-Document Feeder (ADF), 2-line LCD, Security Features, 512 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 1000/1000 pages (black/colour)*\nCompatible with Brother iPrint&Scan Mobile App** & BR Admin**\n1 Year on-site warranty included"
  },
  {
    "productName": "DCP-L3560CDW Multifunction Colour Laser LED Printer with Gigabit Ethernet Brother DCP-L3560CDW Multifunction Colour Laser LED Duplex WIFI ADF Printer With Gigabit Ethernet Connectivity, Ideal For Office",
    "category": "printers",
    "subCategory": "laser printers",
    "productImages": [
      "\\img\\product\\DCP-L3560CDW-1.jpg",
      "\\img\\product\\DCP-L3560CDW-2.jpg",
      "\\img\\product\\DCP-L3560CDW-3.jpg",
      "\\img\\product\\DCP-L3560CDW-4.jpg"
    ],
    "description": "A4 print speed up to 26 ppm (Colour/Black)\nUSB 2.0, LAN, Gigabit Ethernet, WiFi (Dual Band), WiFi Direct, AirPrint, Mopria, Brother iPrint&Scan\nAuto 2-sided (Duplex) printing, ADF (Automatic Document Feeder), Intuitive Buttons, 3.5 Inch TFT colour LCD Display, 512 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 1000/1000 pages (black/colour)*\nCompatible Brother Apps - BRAdmin Light, BRAdmin Pro4 : Windows App (By Download), Web Based Management\n1 Year on-site warranty included"
  },
  {
    "productName": "DCP-L5510DN Laser Printer High-yield printing, fast speeds, and user-friendly interface monochrome laser printers",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-L5510DN-1.jpg",
      "\\img\\product\\DCP-L5510DN-2.jpg"
    ],
    "description": "A4 print speed up to 48 ppm (Black)\nAirPrint, Mopria, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 50 sheets Auto-Document Feeder (ADF), 3.5” Colour LCD touchscreen, Security Features, 2 GB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 11,000 pages (black)*\n1 Year on-site warranty included"
  },
  {
    "productName": "DCP-L5660DN Laser Printer High-yield printing, fast speeds, and user-friendly interface monochrome laser printers",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\DCP-L5660DN-1.jpg",
      "\\img\\product\\DCP-L5660DN-2.jpg",
      "\\img\\product\\DCP-L5660DN-3.jpg",
      "\\img\\product\\DCP-L5660DN-4.jpg",
      "\\img\\product\\DCP-L5660DN-5.jpg",
      "\\img\\product\\DCP-L5660DN-6.jpg"
    ],
    "description": "A4 print speed up to 48 ppm (Black)\nAirPrint, Mopria, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 70 sheets dual CIS Auto-Document Feeder (ADF), 3.5” Colour LCD touchscreen, Security Features, 2GB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 11,000 pages (black)*\n1 Year on-site warranty included"
  },
  {
    "productName": "DCP-T220 Ink Tank Printer User-friendly and super low cost printer for home users",
    "category": "printers",
    "subCategory": "colour printers",
    "productImages": [
      "\\img\\product\\DCP-T220-1.jpg",
      "\\img\\product\\DCP-T220-2.jpg",
      "\\img\\product\\DCP-T220-3.jpg",
      "\\img\\product\\DCP-T220-4.jpg",
      "\\img\\product\\DCP-T220-5.jpg",
      "\\img\\product\\DCP-T220-6.jpg"
    ],
    "description": "A4 print speed up to 16 ipm (Black)/ 9 ipm (Colour)\nUSB 2.0\nIntuitive Buttons, 64 MB Memory, 150 Sheets Paper Tray\nFull ink bottles included. Yield up to 7500/5000 pages (black/colour)*\nCompatible with Brother iPrint&Scan Desktop App** & BR Admin**"
  },
  {
    "productName": "DCP-T226 User-friendly and super low cost printer for home users",
    "category": "printers",
    "subCategory": "inktank printers",
    "productImages": [
      "\\img\\product\\DCP-T226-1.jpg",
      "\\img\\product\\DCP-T226-2.jpg",
      "\\img\\product\\DCP-T226-3.jpg",
      "\\img\\product\\DCP-T226-4.jpg"
    ],
    "description": "A4 print speed up to 16 ipm (Black)/ 9 ipm (Colour)\nUSB 2.0\nIntuitive Buttons, 64 MB Memory, 150 Sheets Paper Tray\nFull ink bottles included. Yield up to 7500/5000 pages (black/colour)*\nCompatible with Brother iPrint&Scan Desktop App** & BR Admin**\n1 year or 30,000 pages on-site warranty included***"
  },
  {
    "productName": "DCP-T420W Refill Tank Printer Affordable printer with wireless and mobile printing for home users",
    "category": "printers",
    "subCategory": "colour printers",
    "productImages": [
      "\\img\\product\\DCP-T420W-1.jpg",
      "\\img\\product\\DCP-T420W-2.jpg",
      "\\img\\product\\DCP-T420W-3.jpg",
      "\\img\\product\\DCP-T420W-4.jpg",
      "\\img\\product\\DCP-T420W-5.jpg",
      "\\img\\product\\DCP-T420W-6.jpg"
    ],
    "description": "A4 print speed up to 16 ipm (Black)/ 9 ipm (Colour)\nWiFi, Mopria, Wireless Direct, USB 2.0\nIntuitive Buttons, 64 MB Memory, 150 Sheets Paper Tray\nFull ink bottles included. Yield up to 7500/5000 pages (black/colour)*"
  },
  {
    "productName": "DCP-T426W Affordable printer with wireless and mobile printing for home users",
    "category": "printers",
    "subCategory": "colour printers",
    "productImages": [
      "\\img\\product\\DCP-T426W-1.jpg",
      "\\img\\product\\DCP-T426W-2.jpg",
      "\\img\\product\\DCP-T426W-3.jpg",
      "\\img\\product\\DCP-T426W-4.jpg"
    ],
    "description": "A4 print speed up to 16 ipm (Black)/ 9 ipm (Colour)\nWiFi, Mopria, Wireless Direct, USB 2.0\nIntuitive Buttons, 64 MB Memory, 150 Sheets Paper Tray\nFull ink bottles included. Yield up to 7500/5000 pages (black/colour)*\n1 year or 30,000 pages on-site warranty included***"
  },
  {
    "productName": "DCP-T520W Ink Tank Printer 3-in-1 multifunction printer with wireless and mobile printing to work-on-the go",
    "category": "printers",
    "subCategory": "colour printers",
    "productImages": [
      "\\img\\product\\DCP-T520W-1.jpg",
      "\\img\\product\\DCP-T520W-2.jpg",
      "\\img\\product\\DCP-T520W-3.jpg",
      "\\img\\product\\DCP-T520W-4.jpg",
      "\\img\\product\\DCP-T520W-5.jpg",
      "\\img\\product\\DCP-T520W-6.jpg"
    ],
    "description": "A4 print speed up to 17 ipm (Black)/ 9.5 ipm (Colour)\nWiFi, AirPrint, Mopria, WiFi Direct, USB 2.0\n1-line LCD, 128 MB Memory, 150 Sheets Paper Tray\nFull ink bottles included. Yield up to 7500/5000 pages (black/colour)*"
  },
  {
    "productName": "DCP-T525W 3-in-1 multifunction printer with wireless and mobile printing to work-on-the go",
    "category": "printers",
    "subCategory": "colour printers",
    "productImages": [
      "\\img\\product\\DCP-T525W-1.jpg",
      "\\img\\product\\DCP-T525W-2.jpg",
      "\\img\\product\\DCP-T525W-3.jpg",
      "\\img\\product\\DCP-T525W-4.jpg"
    ],
    "description": "A4 print speed up to 16 ipm (Black)/ 9 ipm (Colour)\nWiFi, AirPrint, Mopria, WiFi Direct, USB 2.0\n1-line LCD, 128 MB Memory, 150 Sheets Paper Tray\nFull ink bottles included. Yield up to 15000/5000 pages (black/colour)*"
  },
  {
    "productName": "DCP-T820DW Ink Tank Printer Business savings with duplex, high-speed multifunction printer",
    "category": "printers",
    "subCategory": "inktank printers",
    "productImages": [
      "\\img\\product\\DCP-T820DW-1.jpg",
      "\\img\\product\\DCP-T820DW-2.jpg",
      "\\img\\product\\DCP-T820DW-3.jpg",
      "\\img\\product\\DCP-T820DW-4.jpg"
    ],
    "description": "A4 print speed up to 17 ipm (Black)/ 16.5 ipm (Colour)\nWiFi, AirPrint, Mopria, WiFi Direct, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 20 sheets Auto-Document Feeder (ADF), 1-line LCD, 128 MB Memory, 150 Sheets Paper Tray\nFull ink bottles included. Yield up to 15,000/5000 pages (black/colour)*\nCompatible with Mobile Connect App**, iPrint&Scan Desktop App & BR Admin**\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-B2000D Cost Effective Single Function Printer with Automatic 2-sided Printing! Cost Effective Single Function Printer with Automatic 2-sided Printing",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-B2000D-1.jpg",
      "\\img\\product\\HL-B2000D-2.jpg",
      "\\img\\product\\HL-B2000D-3.jpg",
      "\\img\\product\\HL-B2000D-4.jpg",
      "\\img\\product\\HL-B2000D-5.jpg",
      "\\img\\product\\HL-B2000D-6.jpg"
    ],
    "description": "A4 print speed up to 34 ppm (Black)\nUSB 2.0\nAuto 2-sided (Duplex) printing, 32 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-B2080DW Cost Effective Single Function Printer with Automatic 2-sided Printing and Wireless Connectivity Cost Effective Single Function Printer with Automatic 2-sided Printing and Wireless Connectivity",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-B2080DW-1.jpg",
      "\\img\\product\\HL-B2080DW-2.jpg"
    ],
    "description": "A4 print speed up to 34 ppm (Black)\nWiFi, AirPrint, Mopria, WiFi Direct, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 1-line LCD, 64 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-B2100DB Duplex Laser Printer Brother HL-B2100DB Duplex Printer, Best For Home, Small Office With Affordable Toner",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-B2100DB-1.jpg",
      "\\img\\product\\HL-B2100DB-2.jpg"
    ],
    "description": "A4 print speed up to 34 ppm (Black)\nUSB 2.0\nAuto 2-sided (Duplex) printing, Intuitive Buttons, 1 Line LCD Display, 128 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\nCompatible Brother Apps - BRAdmin Pro4 : Windows App (By Download)\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-B2180DW Auto 2-sided feature Toner-Box series Printer",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-B2180DW-1.jpg",
      "\\img\\product\\HL-B2180DW-2.jpg",
      "\\img\\product\\HL-B2180DW-3.jpg",
      "\\img\\product\\HL-B2180DW-4.jpg"
    ],
    "description": "Up to 34/36 ppm\nAutomatic 2-sided (Duplex) Print\nWireless Connectivity"
  },

  {
    "productName": "HL-L2321D High-Speed Mono Laser Printer with Automatic 2-sided Printing",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-L2321D-1.jpg",
      "\\img\\product\\HL-L2321D-2.jpg",
      "\\img\\product\\HL-L2321D-3.jpg",
      "\\img\\product\\HL-L2321D-4.jpg",
      "\\img\\product\\HL-L2321D-5.jpg",
      "\\img\\product\\HL-L2321D-6.jpg"
    ],
    "description": "A4 print speed up to 30 ppm (Black)\nUSB 2.0\nAuto 2-sided (Duplex) printing, Intuitive Buttons, 8 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\nCompatible with Brother iPrint&Scan Mobile App** & BR Admin**\n1 Year on-site warranty included"
  },

  {
    "productName": "HL-L2361DN High-Speed Mono Laser Printer",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-L2361DN-1.jpg",
      "\\img\\product\\HL-L2361DN-2.jpg",
      "\\img\\product\\HL-L2361DN-3.jpg",
      "\\img\\product\\HL-L2361DN-4.jpg",
      "\\img\\product\\HL-L2361DN-5.jpg",
      "\\img\\product\\HL-L2361DN-6.jpg"
    ],
    "description": "A4 print speed up to 30 ppm (Black)\nAirPrint, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 32 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\nCompatible with Brother iPrint&Scan Mobile App** & BR Admin**\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-L2366DW High-Speed Mono Laser Printer with Automatic 2-sided Printing and Wireless Capability",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-L2366DW-1.jpg",
      "\\img\\product\\HL-L2366DW-2.jpg",
      "\\img\\product\\HL-L2366DW-3.jpg",
      "\\img\\product\\HL-L2366DW-4.jpg"
    ],
    "description": "A4 print speed up to 30 ppm (Black)\nWiFi, AirPrint, WiFi Direct, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 1-line LCD, 32 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\nCompatible with Brother iPrint&Scan Mobile App** & BR Admin**\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-L2400D Duplex Laser Printer Brother HL-L2400D Monochrome Laser Duplex Printer",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-L2400D-1.jpg",
      "\\img\\product\\HL-L2400D-2.jpg",
      "\\img\\product\\HL-L2400D-3.jpg",
      "\\img\\product\\HL-L2400D-4.jpg"
    ],
    "description": "A4 print speed up to 30 ppm (Black)\nUSB 2.0\nAuto 2-sided (Duplex) printing, Intuitive Buttons, LED indicator, 64 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 3000 pages (black)*\nCompatible Brother Apps - BRAdmin Pro4 : Windows App (By Download)\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-L2440DW Duplex WIFI Laser Printer Brother HL-L2440DW Mono Laser Dual Band WIFI Duplex Printer For Home & Small Office",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-L2440DW-1.jpg",
      "\\img\\product\\HL-L2440DW-2.jpg",
      "\\img\\product\\HL-L2440DW-3.jpg",
      "\\img\\product\\HL-L2440DW-4.jpg",
      "\\img\\product\\HL-L2440DW-5.jpg",
      "\\img\\product\\HL-L2440DW-6.jpg"
    ],
    "description": "A4 print speed up to 30 ppm (Black)\nUSB 2.0, WiFi (Dual Band), WiFi Direct, AirPrint, Mopria, Mobile Connect\nAuto 2-sided (Duplex) printing, Intuitive Buttons, 1 Line LCD Display, 64 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 3000 pages (black)*\nCompatible Brother Apps - BRAdmin Light, BRAdmin Pro4 : Windows App (By Download)\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-L2460DN Duplex Network Laser Printer Brother HL-L2460DN Mono Laser Duplex Printer With Network Connectivity",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-L2460DN-1.jpg",
      "\\img\\product\\HL-L2460DN-2.jpg"
    ],
    "description": "A4 print speed up to 34 ppm (Black)\nUSB 2.0, LAN, AirPrint, Mopria, Mobile Connect\nAuto 2-sided (Duplex) printing, Intuitive Buttons, 1 Line LCD Display, 128 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 3000 pages (black)*\nCompatible Brother Apps - BRAdmin Light, BRAdmin Pro4 : Windows App (By Download)\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-L2460DW Duplex WIFI Laser Printer Brother HL-L2460DW Fast Mono Laser Dual Band WIFI Duplex Printer",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-L2460DW-1.jpg",
      "\\img\\product\\HL-L2460DW-2.jpg"
    ],
    "description": "A4 print speed up to 34 ppm (Black)\nUSB 2.0, LAN, WiFi (Dual Band), WiFi Direct, AirPrint, Mopria, Mobile Connect\nAuto 2-sided (Duplex) printing, Intuitive Buttons, 1 Line LCD Display, 128 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 3000 pages (black)*\nCompatible Brother Apps - BRAdmin Light, BRAdmin Pro4 : Windows App (By Download)\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-L3220CDW Colour Laser LED Duplex WIFI Printer Brother HL-L3220CDW Colour Laser LED Duplex WIFI Printer, Ideal For Home And Small Office",
    "category": "printers",
    "subCategory": "laser printers",
    "productImages": [
      "\\img\\product\\HL-L3220CDW-1.jpg",
      "\\img\\product\\HL-L3220CDW-2.jpg"
    ],
    "description": "A4 print speed up to 18 ppm (Colour/Black)\nUSB 2.0, WiFi (Dual Band), WiFi Direct, AirPrint, Mopria, Brother iPrint&Scan\nAuto 2-sided (Duplex) printing, Intuitive Buttons, 1 Line LCD Display, 256 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 1000/1000 pages (black/colour)*\nCompatible Brother Apps - BRAdmin Light, BRAdmin Pro4 : Windows App (By Download), Web Based Management\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-L3280CDW Colour Laser LED Duplex WIFI Printer with Gigabit Ethernet Brother HL-L3280CDW Colour Laser LED Duplex WIFI Printer With Gigabit Ethernet Connectivity, Ideal For Home And Small Office",
    "category": "printers",
    "subCategory": "laser printers",
    "productImages": [
      "\\img\\product\\HL-L3280CDW-1.jpg",
      "\\img\\product\\HL-L3280CDW-2.jpg"
    ],
    "description": "A4 print speed up to 26 ppm (Colour/Black)\nUSB 2.0, LAN, Gigabit Ethernet, WiFi (Dual Band), WiFi Direct, AirPrint, Mopria, Brother iPrint&Scan\nAuto 2-sided (Duplex) printing, Intuitive Buttons, 2.7 Inch TFT colour LCD Display, 256 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 1000/1000 pages (black/colour)*\nCompatible Brother Apps - BRAdmin Light, BRAdmin Pro4 : Windows App (By Download), Web Based Management\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-L5000D Efficient High Speed Monochrome Laser Printer",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-L5000D-1.jpg",
      "\\img\\product\\HL-L5000D-2.jpg"
    ],
    "description": "A4 print speed up to 40 ppm (Black)\nUSB 2.0, Parellel Port\nAuto 2-sided (Duplex) printing, 1-line LCD, 512 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 8000 pages (black)*\nCompatible with Brother iPrint&Scan Mobile App** & BR Admin**\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-L5210DN Laser Printer High-yield printing, and fast speeds monochrome laser printers",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-L5210DN-1.jpg",
      "\\img\\product\\HL-L5210DN-2.jpg"
    ],
    "description": "A4 print speed up to 48 ppm (Black)\nAirPrint, Mopria, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 1-line LCD, 1 GB Memory, 250 Sheets Paper Tray,\nFull capacity toner included. Yield up to 11,000 pages (black)*\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-L5210DW Laser Printer Wireless, high printing speed and high printing volume monochrome laser printer",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\HL-L5210DW-1.jpg",
      "\\img\\product\\HL-L5210DW-2.jpg"
    ],
    "description": "A4 print speed up to 48 ppm (Black)\nWiFi (Dual Band), AirPrint, Mopria, WiFi Direct, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 1-line LCD, 1 GB Memory, 250 Sheets Paper Tray,\nFull capacity toner included. Yield up to 11,000 pages (black)*\n1 Year on-site warranty included"
  },
  {
    "productName": "HL-T4000DW A3 Inkjet Printer, Refill Ink Tank Wireless Duplex Print Efficiency Engineered - A3 Refill Ink Tank Printer with Wireless & Ethernet Connectivity, Automatic 2-sided Colour Print, Professionally Designed for Fast Print Speeds, Low Cost High Photo Quality with Ultra High Yield Ink Bottles, Wi-Fi Direct, Mobile & USB Print",
    "category": "printers",
    "subCategory": "colour printers",
    "productImages": [
      "\\img\\product\\HL-T4000DW-1.jpg",
      "\\img\\product\\HL-T4000DW-2.jpg",
      "\\img\\product\\HL-T4000DW-3.jpg",
      "\\img\\product\\HL-T4000DW-4.jpg",
      "\\img\\product\\HL-T4000DW-5.jpg",
      "\\img\\product\\HL-T4000DW-6.jpg"
    ],
    "description": "A4 print speed up to 22 ipm (Black)/ 20 ipm (Colour)\nWiFi, AirPrint, Mopria, WiFi Direct, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 2.7” Colour LCD touchscreen, 128 MB Memory, 250 Sheets Paper Tray\nCompatible with Brother iPrint&Scan Mobile App** & BR Admin**"
  },
  {
    "productName": "MFC-B7715DW Cost Effective 4-in-1 Mono Laser Multi-Function Centre with Automatic 2-sided Printing and Wireless Networking Cost Effective 4-in-1 Mono Laser Multi-Function Centre with Automatic 2-sided Printing and Wireless Networking",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\MFC-B7715DW-1.jpg",
      "\\img\\product\\MFC-B7715DW-2.jpg",
      "\\img\\product\\MFC-B7715DW-3.jpg",
      "\\img\\product\\MFC-B7715DW-4.jpg"
    ],
    "description": "A4 print speed up to 34 ppm (Black)\nWiFi, AirPrint, Mopria, WiFi Direct, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 50 sheets Auto-Document Feeder (ADF), 2-line LCD, 128 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\n1 Year on-site warranty included"
  },
  {
    "productName": "MFC-B7810DW",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\MFC-B7810DW-1.jpg",
      "\\img\\product\\MFC-B7810DW-2.jpg"
    ],
    "description": "Up to 34/36 ppm\nAutomatic 2-sided (Duplex) Print\nAutomatic Doucment Feeder (up to 50 Sheets(A4/Letter))"
  },
  {
    "productName": "MFC-B7810DWB (Print Scan Copy Fax) WIFi Duplex ADF Laser Printer Brother MFC-B7810DWB Fast Multifunction WIFI Duplex Printer, ADF, Best For Business With Affordable Toner",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\MFC-B7810DWB-1.jpg",
      "\\img\\product\\MFC-B7810DWB-2.jpg"
    ],
    "description": "A4 print speed up to 34 ppm (Black)\nUSB 2.0, LAN, WiFi, WiFi Direct, AirPrint, Mopria, Mobile Connect\nAuto 2-sided (Duplex) printing, ADF (Automatic Document Feeder), Intuitive Buttons, 2 Line LCD Display, 256 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\nCompatible Brother Apps - BRAdmin Light, BRAdmin Pro4 : Windows App (By Download)\n1 Year on-site warranty included"
  },
  {
    "productName": "MFC-L2701D 5-in-1 Monochrome Laser Multi-Function Centre",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\MFC-L2701D-1.jpg",
      "\\img\\product\\MFC-L2701D-2.jpg"
    ],
    "description": "A4 print speed up to 30 ppm (Black)\nUSB 2.0\nAuto 2-sided (Duplex) printing, 35 sheets Auto-Document Feeder (ADF), 2-line LCD, 2 in 1 (ID) Copy, 32 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 2600 pages (black)*\n1 Year on-site warranty included"
  },
  {
    "productName": "MFC-L3735CDN : Network Colour LED All-in-One, Duplex Mobile Print ADF Colour LED Multi-Function Centre with Network Connectivity, Automatic 2-sided Colour Print, ADF -  Multi-page Scan, Copy, Fax, High Productivity with Fast Print Speeds & Multi-tasking, Direct Mobile Print, Low Cost Quality Print Resolution with Affordable Toner",
    "category": "printers",
    "subCategory": "laser printers",
    "productImages": [
      "\\img\\product\\MFC-L3735CDN-1.jpg",
      "\\img\\product\\MFC-L3735CDN-2.jpg",
      "\\img\\product\\MFC-L3735CDN-3.jpg",
      "\\img\\product\\MFC-L3735CDN-4.jpg",
      "\\img\\product\\MFC-L3735CDN-5.jpg",
      "\\img\\product\\MFC-L3735CDN-6.jpg"
    ],
    "description": "A4 print speed up to 24 ppm (Black/Colour)\nAirPrint, Mopria, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 50 sheets Auto-Document Feeder (ADF), 3.7” Colour LCD touchscreen, Security Features, 512 MB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 1000/1000 pages (black/colour)*\nCompatible with Brother iPrint&Scan Mobile App** & BR Admin**\n1 Year on-site warranty included"
  },

  {
    "productName": "MFC-L5915DW Laser Printer Wireless, high printing speed with 5-inch LCD touchscreen monochrome laser printer",
    "category": "printers",
    "subCategory": "mono laser printers",
    "productImages": [
      "\\img\\product\\MFC-L5915DW-1.jpg",
      "\\img\\product\\MFC-L5915DW-2.jpg"
    ],
    "description": "A4 print speed up to 50 ppm (Black)\nWiFi (Dual Band), AirPrint, Mopria, WiFi Direct, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 70 sheets dual CIS Auto-Document Feeder (ADF), 5” Colour LCD touchscreen, Security Features, 2 GB Memory, 250 Sheets Paper Tray\nFull capacity toner included. Yield up to 11,000 pages (black)*\n1 Year on-site warranty included"
  },
  {
    "productName": "MFC-T4500DW A3 Inkjet MFC Refill Ink Tank Wireless Duplex All-in-One Efficiency Engineered - A3 Refill Ink Tank Multi-Function Centre with Wireless & Ethernet Connectivity, Automatic 2-sided Colour Print, ADF - Scan/Copy/Fax. Professionally Designed for Fast Print Speeds, Low Cost High Resolution Photo Quality with Ultra High Yield Ink Bottles, Wi-Fi Direct, Mobile & USB Print",
    "category": "printers",
    "subCategory": "colour printers",
    "productImages": [
      "\\img\\product\\MFC-T4500DW-1.jpg",
      "\\img\\product\\MFC-T4500DW-2.jpg",
      "\\img\\product\\MFC-T4500DW-3.jpg",
      "\\img\\product\\MFC-T4500DW-4.jpg",
      "\\img\\product\\MFC-T4500DW-5.jpg",
      "\\img\\product\\MFC-T4500DW-6.jpg",
      "\\img\\product\\MFC-T4500DW-7.jpg",
      "\\img\\product\\MFC-T4500DW-8.jpg"
    ],
    "description": "A4 print speed up to 22 ipm (Black)/ 20 ipm (Colour)\nWiFi, AirPrint, Mopria, WiFi Direct, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 50 sheets Auto-Document Feeder (ADF), 2.7” Colour LCD touchscreen, 128 MB Memory, 250 Sheets Paper Tray\nCompatible with Brother iPrint&Scan Mobile App** & BR Admin**"
  },
  {
    "productName": "MFC-T920DW Ink Tank Printer The all-in-one printer with high volume printing at a low cost for businesses",
    "category": "printers",
    "subCategory": "colour printers",
    "productImages": [
      "\\img\\product\\MFC-T920DW-1.jpg",
      "\\img\\product\\MFC-T920DW-2.jpg"
    ],
    "description": "A4 print speed up to 17 ipm (Black)/ 16.5 ipm (Colour)\nWiFi, AirPrint, Mopria, WiFi Direct, LAN, USB 2.0\nAuto 2-sided (Duplex) printing, 20 sheets Auto-Document Feeder (ADF), 1.8” LCD screen, 128 MB Memory, 150 Sheets Paper Tray\nFull ink bottles included. Yield up to 15000/5000 pages (black/colour)*"
  },
  {
    "productName": "PT-D210 Portable Desktop Label Maker All-new standalone label maker for personal purposes of hobby and home use",
    "category": "labellers",
    "subCategory": "laminated label printers",
    "productImages": [
      "\\img\\product\\PT-D210-1.jpg",
      "\\img\\product\\PT-D210-2.jpg",
      "\\img\\product\\PT-D210-3.jpg",
      "\\img\\product\\PT-D210-4.jpg"
    ],
    "description": "Print up to 12mm TZe laminated tapes width\nQWERTY Keyboard\nManual cut function\nOne-touch keys for easy label creation\nDecorative frames and symbols\n97 frames, 14 font styles, 617 symbols, 30 memories"
  },

  {
    "productName": "PT-D610BT Desktop Label Printer Desktop Bluetooth and PC Connectable Label Printer with Colour LCD display",
    "category": "labellers",
    "subCategory": "laminated label printers",
    "productImages": [
      "\\img\\product\\PT-D610BT-1.jpg",
      "\\img\\product\\PT-D610BT-2.jpg",
      "\\img\\product\\PT-D610BT-3.jpg",
      "\\img\\product\\PT-D610BT-4.jpg"
    ],
    "description": "Print up to 24mm TZe laminated tapes width\nPrint up to 24mm TZe laminated tapes width\nAuto cut function\nFull-Colour LCD screen with backlight\nEditable label templates\nAuto tapes colour and size detection"
  },
  {
    "productName": "PT-E110VP Handheld Label Printer Label printer for electrical and datacom installations",
    "category": "labellers",
    "subCategory": "laminated label printers",
    "productImages": [
      "\\img\\product\\PT-E110VP-1.jpg",
      "\\img\\product\\PT-E110VP-2.jpg",
      "\\img\\product\\PT-E110VP-3.jpg",
      "\\img\\product\\PT-E110VP-4.jpg",
      "\\img\\product\\PT-E110VP-5.jpg",
      "\\img\\product\\PT-E110VP-6.jpg"
    ],
    "description": "Print up to 12mm TZe laminated tapes width\nQWERTY keyboard\nManual cut function\nDedicated function keys for electrical and datacom\nComes with hard carrying case\n1 frames, 10 font styles, 200 symbols, 9 memories"
  },
  {
    "productName": "PT-E550WVP Handheld Label Printer All-in-one wireless-enabled label printer",
    "category": "labellers",
    "subCategory": "laminated label printers",
    "productImages": [
      "\\img\\product\\PT-E550WVP-1.jpg",
      "\\img\\product\\PT-E550WVP-2.jpg",
      "\\img\\product\\PT-E550WVP-3.jpg",
      "\\img\\product\\PT-E550WVP-4.jpg"
    ],
    "description": "Print up to 24mm TZe laminated tapes width\nQWERTY Keyboard, USB and WiFi connection\nAuto and Half cut function\nDedicated function keys for electrical and datacom\nComes with hard carrying case\nRechargeable Li-ion battery included"
  },
  {
    "productName": "PT-E850TKW Ferrule Printing Machine Industrial tube and label printer designed to meet the diverse needs of electricians",
    "category": "labellers",
    "subCategory": "laminated label printers",
    "productImages": [
      "\\img\\product\\PT-E850TKW-1.jpg",
      "\\img\\product\\PT-E850TKW-2.jpg",
      "\\img\\product\\PT-E850TKW-3.jpg"
    ],
    "description": "Print up to 36mm TZe laminated tapes width and φ 2.5 - φ 6.5 PVC Tubes\nQWERTY Keyboard, USB and WiFi connection\nAuto and Half cut function\nTwin-engine for tube and label\nSelf-replaceable Tube cleaner, cutter and rollers\nOptional Rechargeable Li-ion battery"
  },
  {
    "productName": "PT-H105 Handheld Portable Label Printer Portable hand-held label printer",
    "category": "labellers",
    "subCategory": "laminated label printers",
    "productImages": [
      "\\img\\product\\PT-H105-1.jpg",
      "\\img\\product\\PT-H105-2.jpg",
      "\\img\\product\\PT-H105-3.jpg",
      "\\img\\product\\PT-H105-4.jpg",
      "\\img\\product\\PT-H105-5.jpg",
      "\\img\\product\\PT-H105-6.jpg"
    ],
    "description": "Print up to 12mm TZe laminated tapes width\nABC Keyboard\nManual cut function\nCompact and Portable\nDecorative frames and symbols\n7 frames, 9 font styles, 178 symbols, 9 memories"
  },
  {
    "productName": "PT-P900W Professional Desktop Label Printer Portable hand-held electronic label printer",
    "category": "labellers",
    "subCategory": "laminated label printers",
    "productImages": [
      "\\img\\product\\PT-P900W-1.jpg",
      "\\img\\product\\PT-P900W-2.jpg",
      "\\img\\product\\PT-P900W-3.jpg",
      "\\img\\product\\PT-P900W-4.jpg"
    ],
    "description": "Print up to 36mm TZe laminated tapes width\nUSB and WiFi connection\nAuto and Half cut function\nHigh print resolution up to 360dpi x 720dpi\nFast print speed of up to 60mm per second\nPrint images, barcodes, frames and imported database"
  },
  {
    "productName": "QL-800 Professional Label Printer High Speed Professional Label Printer",
    "category": "labellers",
    "subCategory": "paper label printers",
    "productImages": [
      "\\img\\product\\QL-800-1.jpg",
      "\\img\\product\\QL-800-2.jpg"
    ],
    "description": "Print up to 62mm DK rolls width\nUSB connection\nAuto cut function\nPrints Red/Black on White label\nFast print speed of up to 148mm per second\nComes with Label collection templates"
  },
  {
    "productName": "QL-810W Professional Wireless Label Printer High Speed Professional Wireless Label Printer",
    "category": "labellers",
    "subCategory": "paper label printers",
    "productImages": [
      "\\img\\product\\QL-810W-1.jpg",
      "\\img\\product\\QL-810W-2.jpg"
    ],
    "description": "Print up to 62mm DK rolls width\nUSB and WiFi connection\nAuto cut function\nPrints Red/Black on White label\nFast print speed of up to 176mm per second\nComes with Label collection templates"
  },
  {
    "productName": "QL-820NWB Professional Label Printer High Speed Professional Wireless WIFI Label Printer",
    "category": "labellers",
    "subCategory": "paper label printers",
    "productImages": [
      "\\img\\product\\QL-820NWB-1.jpg",
      "\\img\\product\\QL-820NWB-2.jpg",
      "\\img\\product\\QL-820NWB-3.jpg",
      "\\img\\product\\QL-820NWB-4.jpg",
      "\\img\\product\\QL-820NWB-5.jpg",
      "\\img\\product\\QL-820NWB-6.jpg"
    ],
    "description": "Print up to 62mm DK rolls width\nUSB, USB host, Bluetooth, Wired LAN and WiFi connection\nAuto cut function\nStandalone print without PC required\nFast print speed of up to 176mm per second\nStand-alone Time-stamping function"
  }
]